import React from "react";
import { goApi } from "../../services";

const ItemName = ({ productId }: { productId: any }) => {
    const [name, setName] = React.useState("");

    React.useEffect(() => {
        if (!productId) return;

        goApi.get(`/ecom/products/${productId}`)
            .then(res => setName(res.data.name))
            .catch(() => setName("ERROR"));
    }, [productId]);

    return <div>{name}</div>;
};
export default ItemName;
